import { initialState } from '../../../redux/POS/reducers/orderAdjustment';

export default orderId => {
  const adjustment = localStorage.getItem(`orderAdjustment_${orderId}`);
  return JSON.parse(adjustment) || initialState;
};
